import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({
  to,
  onClick,
  children,
  variant = 'primary',
  className = '',
  disabled = false,
  icon: Icon,
  type,
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-semibold py-2.5 px-5 rounded-lg shadow-md transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2';

  const variantClasses = {
    primary: 'custom-btn-secondary text-white hover:shadow-lg',
    secondary: 'bg-neutral-200 text-neutral-800 hover:bg-neutral-300',
    warning: 'bg-amber-500 text-white hover:bg-amber-600 hover:shadow-lg',
    success: 'bg-green-500 text-white hover:bg-green-600 hover:shadow-lg',
    danger: 'bg-red-500 text-white hover:bg-red-600 hover:shadow-lg',
  };

  const combinedClasses = `${baseClasses} ${variantClasses[variant]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`;

  const content = (
    <>
      {Icon && <Icon className="w-5 h-5 mr-2 -ml-1" />}
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={combinedClasses} {...props}>
        {content}
      </Link>
    );
  }

  return (
    <button 
      type={type}
      onClick={onClick} 
      className={combinedClasses} 
      disabled={disabled} 
      {...props}
    >
      {content}
    </button>
  );
};

export default Button;
